export default {
  nav: {
    main: 'Principal',
    ordersAndInvoices: 'Comenzi si Facturi',
    drafts: 'Ciorne',
    automation: 'Automatizare',
    workspace: 'Spatiu de lucru',
    templates: 'Sabloane',
    delivery: 'Livrare',
    settings: 'Setari',
    shippingLabels: 'Etichete de expeditie',
    subscriptions: 'Abonamente',
    support: 'Suport',
    developer: 'Dezvoltator',
    writeReview: 'Scrie o recenzie',
    supportTicket: 'Tichet de suport',
    welcomeTour: 'Tur de bun venit',
    administratorConsole: 'Consola de administrare',
    logout: 'Deconectare',
  },
  dashboard: {
    pageTitle: 'Comenzi si Facturi',
    pageDescription: 'Manage your orders and invoices',
    title: 'Comenzi si Facturi',
    selectedOrders: '{count} comenzi selectate',
    completed: '% completat',
    processing: 'Se proceseaza, va rugam asteptati...',
    bulkDownload: 'Descarcare in masa',
    upgradeBulkDownload: 'Upgradati planul pentru Descarcare in masa',
    showFilters: 'Arata filtrele',
    hideFilters: 'Ascunde filtrele',
    creatingInvoices: 'Se creaza facturile, va rugam asteptati...',
    bulkCreateInvoices: 'Creare facturi in masa',
    cannotCreateAutopilot: 'Nu puteti crea facturi manual cand modul de facturare este pe auto-pilot.',
    exportInvoices: 'Exporta facturi sau comenzi',
    capturePayments: 'Capturare plati manual',
    filterOrders: 'Filtreaza comenzi',
    error: 'Hei, ceva nu a mers bine...',
    close: 'Inchide',
    chooseDate: 'Alege o data',
    chooseIssueDate: 'Alege o data de emitere pentru facturile selectate',
    cancel: 'Anuleaza',
    createInvoices: 'Creeaza Facturi',
    storno: 'Storno',
    bulkOrderCapture: 'Capturare comenzi in masa',
  },
  search: {
    createdBetween: 'Creat intre',
    modifiedBetween: 'Modificat intre',
    orderNumber: 'Comanda #',
    invoiceNumber: 'Factura #',
    refundNumber: 'Rambursare #',
    customer: 'Client',
    payment: 'Plata',
    any: 'Oricare',
    authorized: 'Autorizat',
    pending: 'În așteptare',
    paid: 'Plătit',
    partiallyPaid: 'Plătit parțial',
    refunded: 'Rambursat',
    voided: 'Anulat',
    partiallyRefunded: 'Rambursat parțial',
    unpaid: 'Neplătit',
    fulfillment: 'Onorare',
    fulfilled: 'Livrat',
    partial: 'Parțial',
    unfulfilled: 'Nelivrat',
    loading: 'Se incarca comenzile...',
    search: 'Cauta',
  },
  orderList: {
    noCustomer: 'Fara client',
    downloadOrder: 'Descarca comanda',
    deleteWarning: 'Important! Aceasta actiune va sterge toate facturile si rambursarile create dupa data:',
    includingInvoice: 'inclusiv factura selectata #',
    pressOk: 'Apasati OK pentru a continua sau Anuleaza pentru a renunta.',
    cannotCreateAutopilot: 'Nu puteti crea facturi manual cand modul de facturare este pe auto-pilot.',
    createInvoice: 'Creeaza factura pentru aceasta comanda',
    create: 'Creeaza',
    addCreditNote: 'Adauga nota de credit',
    createStorno: 'Creeaza o factura storno',
    refund: 'Rambursare',
    downloadInvoice: 'Descarca aceasta factura',
    download: 'Descarca',
    default: 'Implicit',
    downloadStorno: 'Descarca aceasta factura storno/nota de credit',
    fulfillOrder: 'Onoreaza comanda',
    orderNum: 'Comanda #',
    locPrefix: 'Prefix locatie',
    invoiceNum: 'Factura #',
    refundNum: 'Rambursare #',
    customerCol: 'Client',
    orderCreatedDate: 'Data creare comanda',
    orderModifiedDate: 'Data modificare comanda',
    delivered: 'Livrat',
    paymentStatus: 'Stare plata',
    fulfillmentStatus: 'Status livrare',
    totalOutstanding: 'Total suma restanta',
    originalPrice: 'Pret original',
    noOrders: 'Magazinul dumneavoastra nu are comenzi pentru statusul selectat.',
    cannotCreateNoOrders: 'Nu puteti crea facturi cand nu exista comenzi.',
    createOrdersFirst: 'Va rugam creati cel putin o comanda si incercati din nou.',
    createOrders: 'Creeaza comenzi',
    loadingOrders: 'Se incarca...',
    paidManual: 'Plătit - Manual',
    paid: 'Plătit',
    refunded: 'Rambursat',
    pending: 'În așteptare',
    partiallyPaid: 'Plătit parțial',
    partiallyRefunded: 'Rambursat parțial',
    fulfilled: 'Livrat',
    unfulfilled: 'Nelivrat',
    deliveryPending: 'În așteptare',
    deliverNow: 'Livrează acum',
    deliveryPartial: 'Parțial',
    notDelivered: 'Nelivrat',
    deliverAgain: 'Livrează din nou',
    deliveryDetails: 'Detalii livrare',
    deliveryFailed: 'Livrare eșuată',
    sent: 'Trimis',
    failed: 'Eșuat',
    toLabel: 'Către',
    folderLabel: 'Dosar',
    open: 'Deschis',
    invoice: 'Factură',
    creditNote: 'Notă de credit',
    stornoLabel: 'Storno',
    unknown: 'Necunoscut',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tabletă clienți',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Revenire la această dată',
    add: 'Adaugă',
    close: 'Închide',
  },
  downloadDialog: {
    downloadType: 'Descarca {type}...',
    selectTemplate: 'Selectati un sablon din galerie pentru a exporta comenzi, facturi, facturi storno sau note de credit.',
    getMoreTemplates: 'Obtine mai multe sabloane',
    createNewTemplate: 'Creeaza un sablon nou',
    allCreatedBetween: 'Toate {type} create intre',
    selectedType: '{type} selectate',
    and: 'si',
    status: 'Status',
    any: 'Oricare',
    open: 'Deschis',
    closed: 'Inchis',
    cancelled: 'Anulat',
    paymentStatus: 'Stare plata',
    fulfillmentStatus: 'Status livrare',
    fulfilled: 'Livrat',
    partial: 'Parțial',
    unfulfilled: 'Nelivrat',
    authorized: 'Autorizat',
    pending: 'În așteptare',
    paid: 'Plătit',
    partiallyPaid: 'Plătit parțial',
    refunded: 'Rambursat',
    voided: 'Anulat',
    partiallyRefunded: 'Rambursat parțial',
    unpaid: 'Neplătit',
    format: 'Format',
    forLocation: 'Pentru locație',
    advancedOptions: 'Opțiuni avansate',
    exportHSCodes: 'Exportă coduri HS inventar (mai lent)',
    noteChrome: 'Notă: Pentru descărcare optimă se recomandă Chrome și dezactivarea oricărui adblocker.',
    downloadIndividually: 'Descarcă individual',
    downloadGrouped: 'Descarcă grupat',
  },
  templates: {
    pageTitle: 'Sabloane',
    pageDescription: 'Customize your invoice templates',
    title: 'Sabloane',
    installTranslated: 'Instaleaza un sablon tradus',
    installTranslatedDesc: 'Alege o alta limba apasand pe acest buton.',
    createNew: 'Creeaza un sablon nou daca este necesar',
    createNewDesc: 'Apasa pe acest buton pentru a crea un sablon nou daca este necesar.',
    customize: 'Personalizeaza sabloanele',
    customizeDesc: 'Apasa pe sablonul implicit pentru a-l personaliza. Poti schimba logo-ul, culorile si, pentru utilizatorii avansati, codul din spate.',
    defaultTemplate: 'Factura, Storno si Nota de credit (Implicit)',
    logo: 'Logo',
    colorPalette: 'Paleta de culori',
    getColorPalettes: 'Obtine palete de culori',
    paperSize: 'Dimensiune hartie',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientare',
    landscape: 'Peisaj',
    portrait: 'Portret',
    margin: 'Margine (cm)',
    unsavedChanges: 'Modificari nesalvate',
    discard: 'Renunta',
    save: 'Salveaza',
  },
  labels: {
    pageTitle: 'Etichete de expeditie',
    pageDescription: 'Create and manage shipping labels',
    title: 'Etichete de expeditie',
    glsRequiresPro: 'Etichetele de expeditie GLS pentru EEU necesita planul Professional.',
    upgradeDesc: 'Upgradati la Professional pentru a crea si gestiona etichete de expeditie.',
    upgradePlan: 'Upgradati planul',
    eeuGls: 'EEU GLS',
    enabled: 'Activat',
    country: 'Tara',
    hungary: 'Ungaria',
    slovakia: 'Slovacia',
    czech: 'Cehia',
    romania: 'Romania',
    slovenia: 'Slovenia',
    croatia: 'Croatia',
    senderId: 'ID Expeditor',
    username: 'Utilizator',
    password: 'Parola',
    name: 'Nume',
    city: 'Oras',
    address: 'Adresa',
    zipCode: 'Cod postal',
    contactPerson: 'Persoana de contact',
    phone: 'Telefon',
    email: 'Email',
    glsServices: 'Servicii GLS',
    expressService: 'Serviciu Express',
    exchangeService: 'Serviciu de schimb',
    smsService: 'Serviciu SMS',
    smsText: 'Text SMS',
    preAdviceService: 'Serviciu PreAdvice',
    unsavedChanges: 'Modificari nesalvate',
    discard: 'Renunta',
    save: 'Salveaza',
  },
  billing: {
    pageTitle: 'Facturare',
    pageDescription: 'Manage your subscription and billing',
    title: 'Facturare',
    subscriptionFor: 'Plan de abonament pentru magazinul',
    currentlySubscribed: 'Sunteti abonat in prezent la',
    plan: 'plan',
    cancelSubscription: 'Anuleaza abonamentul',
    upgradePlan: 'Upgradati planul',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / luna',
    upgrade: 'Upgrade',
    includesAllStarter: 'Include toate functiile Starter, plus:',
    proFeature1: 'Suita de conformitate globala: Prefixe bazate pe locatie si numerotare secventiala personalizata',
    proFeature2: 'Localizare inteligenta: Emailuri traduse automat si atasamente PDF localizate',
    proFeature3: 'Ciclu complet de documente B2B: Proforme, Oferte B2B si Note de credit',
    proFeature4: 'Sincronizare contabila B2B: Precizie de 3 zecimale si afisare multi-valuta',
    proFeature5: 'Backup automat: Copiaza facturile automat pe FTP securizat sau Google Drive',
    proFeature6: 'Shopify Flow: Automatizeaza generarea, livrarea si stornarea facturilor prin triggere si actiuni Flow',
    proFeature7: 'Logica AI avansata: Folositi AI-ul pe dispozitiv pentru clauze conditionale complexe de layout',
    proFeature8: 'Exporturi UBL XML & ZUGFeRD / Factur-X (conformitate E-facturare europeana)',
    proFeature9: 'Coduri EPC QR pentru plati mobile instantanee POS',
    proFeature10: 'Etichete de expeditie GLS pentru EEU',
    proFeature11: 'Retentie fiscala de conformitate pe 7 ani',
    currentlyUsing: 'Utilizati in prezent planul nostru',
    free: 'gratuit',
    subscriptionPlan: 'de abonament.',
    monthlyUsage: 'Utilizare lunara',
    monthlyGenerated: '{count} / 50 facturi luna aceasta',
    monthlyLimitReached: 'Limita lunara atinsa. Upgradati la Starter pentru facturi nelimitate.',
    freePlan: 'Plan Gratuit',
    freeToInstall: 'Gratuit de instalat',
    freeFeature1: 'Pana la 50 facturi/comenzi pe luna',
    freeFeature2: 'Acces la toate cele 31+ sabloane predefinite',
    freeFeature3: 'AI Copilot de baza',
    freeFeature4: 'Descarcare si tiparire PDF standard',
    freeFeature5: 'Suita de documente standard (Facturi, Avize de expeditie, Chitante)',
    freeFeature6: 'Retentie securizata a facturilor pe 3 luni',
    starterPlan: 'Plan Starter',
    starterPrice: '$9.99 / luna',
    starterPricePerInvoice: '+ 3¢ per factura creata',
    subscribe: 'Aboneaza-te',
    starterFeature1: 'Facturi si comenzi nelimitate',
    starterFeature2: 'Livrare automata PDF prin email',
    starterFeature3: 'Acces complet la editorul hibrid si AI Copilot',
    starterFeature4: 'Integrare Shopify POS si coduri de bare',
    starterFeature5: 'Shopify Flow: Triggere si actiuni pentru automatizarea facturilor',
    starterFeature6: 'Exporturi UBL XML / PEPPOL & ZUGFeRD / Factur-X (conformitate E-facturare)',
    starterFeature7: 'Retentie securizata a facturilor pe 1 an',
    proTaxOverrides: 'Suprascrierea taxelor personalizate: TVA / GST per produs si rate la nivel de SKU',
    unsavedChanges: 'Modificari nesalvate',
    discard: 'Renunta',
    save: 'Salveaza',
  },
  autopilot: {
    pageTitle: 'Automatizare',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatizare',
    autoCreate: 'Creeaza facturi automat',
    disabled: 'Dezactivat (Manual)',
    whenCreated: 'Cand comenzile sunt create',
    whenFulfilled: 'Cand comenzile sunt onorate',
    whenPaid: 'Cand comenzile sunt platite',
    autoCreateDesc: 'Facturile vor fi create la data cand comenzile sunt create, onorate sau platite.',
    autoStorno: 'Stornare automata a facturilor',
    whenCancelled: 'Cand comenzile sunt anulate sau rambursate',
    autoStornoDesc: 'Facturile storno vor fi create la data cand comenzile sunt anulate sau rambursarile sunt create.',
    cannotAutoFree: 'Crearea automata a facturilor nu poate fi efectuata cu planul gratuit.',
    upgradePlan: 'Upgradati planul',
    unsavedChanges: 'Modificari nesalvate',
    discard: 'Renunta',
    save: 'Salveaza',
  },
  delivery: {
    pageTitle: 'Livrare',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Livrare',
    settings: 'Setari',
    useOrderNumbers: 'Foloseste numerele de comanda pentru fisiere',
    sendIfCountry: 'Trimite daca tara adresei de facturare este',
    countryCodesHint: 'Listeaza toate codurile de tara separate prin punct si virgula.',
    sendForTags: 'Trimite pentru clientii care au unul din tag-urile listate',
    tagsHint: 'Listeaza toate tag-urile separate prin punct si virgula.',
    emailDelivery: 'Livrare prin email',
    sendAsPdf: 'Trimite facturile ca atasamente PDF catre clienti',
    autoSend: 'Trimite automat cand o factura este creata',
    subject: 'Subiect',
    body: 'Continut',
    xmlAttachments: 'Atasamente XML',
    attachUbl: 'Ataseaza UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Ataseaza ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Trimite email de test',
    sending: 'Se trimite...',
    customSmtp: 'Server SMTP personalizat',
    customSmtpDesc: 'Foloseste propriul server de email in loc de cel implicit',
    enableSmtp: 'Activeaza SMTP personalizat',
    smtpHost: 'Host SMTP',
    port: 'Port',
    useSsl: 'Foloseste SSL/TLS',
    username: 'Utilizator',
    password: 'Parola',
    fromEmail: 'Email expeditor',
    fromName: 'Nume expeditor',
    shopifyLiquid: 'Sablon Shopify Liquid',
    pasteInto: 'Lipeste acest cod in',
    orderConfirmation: 'sablonul de confirmare a comenzii',
    toAddLink: 'pentru a adauga un link de descarcare.',
    downloadInvoice: 'Descarca factura ta',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Trimite cereri catre ClientsTablet cand facturile sunt create',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Trimite facturi PDF ca documente vamale catre ShippyPro pentru tarile din afara UE',
    ftpBackup: 'Backup FTP / SFTP',
    ftpDesc: 'Copiaza automat facturile pe serverul dumneavoastra',
    enableFtp: 'Activeaza backup FTP automat',
    host: 'Host',
    useSftp: 'Foloseste SFTP (securizat)',
    destinationFolder: 'Folder destinatie',
    xmlFiles: 'Fisiere XML',
    includeUbl: 'Include UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Include ZUGFeRD / Factur-X XML',
    testConnection: 'Testeaza conexiunea',
    testing: 'Se testeaza...',
    pro: 'PRO',
    upgradeFtp: 'Upgradati la Professional pentru a copia automat facturile pe serverul FTP/SFTP.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Sincronizeaza automat facturile in Drive',
    connected: 'Conectat',
    disconnect: 'Deconecteaza',
    notWorking: 'Nu functioneaza? Accesati',
    googlePermissions: 'Permisiuni Google',
    removeThenReconnect: 'eliminati Invoice Browse, apoi reconectati.',
    connectGoogleDrive: 'Conecteaza Google Drive',
    upgradeGoogleDrive: 'Upgradati la Professional pentru a sincroniza automat facturile in Google Drive.',
    unsavedChanges: 'Modificari nesalvate',
    discard: 'Renunta',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Salveaza',
  },
  bookkeeping: {
    pageTitle: 'Setari',
    pageDescription: 'Configure your invoice settings',
    title: 'Setari',
    owner: 'Proprietar',
    email: 'Email',
    phone: 'Telefon',
    keepDifferentNumbering: 'Pastreaza numerotare diferita a facturilor pentru fiecare locatie de comanda',
    keepDifferentNumberingDisabled: 'Pastrarea unei numerotari diferite a facturilor pentru fiecare locatie de comanda nu este o optiune activata cu planul dumneavoastra.',
    locationEmailDesc: 'Aceasta va permite sa trimiteti emailuri si facturi traduse pe baza locatiei comenzii: locatie de inventar, adresa de livrare sau facturare',
    upgradePlan: 'Upgradati planul',
    matchingCriteria: 'Criterii de potrivire',
    locationId: 'ID Locatie',
    shippingCountryCode: 'Cod tara adresa de livrare',
    billingCountryCode: 'Cod tara adresa de facturare',
    matchLocationDesc: 'Potriveste o locatie pe baza ID-ului locatiei comenzii, codului de tara al adresei de livrare sau facturare.',
    companyInfo: 'Informatii companie',
    name: 'Nume',
    website: 'Website',
    registrationNumber: 'Numar de inregistrare',
    taxId: 'Cod fiscal',
    addressSection: 'Adresa',
    streetName: 'Nume strada',
    streetNumber: 'Numar strada',
    zip: 'Cod postal',
    city: 'Oras',
    region: 'Regiune',
    country: 'Tara',
    bankingInfo: 'Informatii bancare',
    bankName: 'Nume banca',
    swift: 'Swift',
    currency: 'Valuta',
    iban: 'IBAN',
    invoicing: 'Facturare',
    decimalPlaces: 'Zecimale',
    invoicesPrefix: 'Prefix facturi',
    currentInvoiceNumber: 'Numar factura curent',
    creditNotesPrefix: 'Prefix note de credit',
    currentCreditNoteNumber: 'Numar nota de credit curent',
    lastInvoiceDate: 'Data ultimei facturi',
    noInvoicesYet: 'Nicio factura creata inca.',
    confirmReverting: 'Confirmare revenire sistem',
    allInvoicesAfter: 'Toate facturile si storno-urile emise dupa',
    willBeRemoved: 'vor fi sterse. Continuati cu revenirea sistemului?',
    cancel: 'Anuleaza',
    revert: 'Revino',
    revertDesc: 'Revenirea sistemului va sterge toate facturile create dupa data selectata.',
    revertToDate: 'Revino la aceasta data',
    reverting: 'Se revine la starea anterioara, va rugam asteptati...',
    useOrderNumbering: 'Foloseste numerotarea comenzilor',
    showVat: 'Afiseaza TVA pe facturi',
    overrideTaxes: 'Suprascrie taxele',
    pricesIncludeTax: 'Preturile includ taxe',
    productsTaxRate: 'Rata taxa produse',
    shippingTaxRate: 'Rata taxa livrare',
    skusSeparated: 'SKU-uri separate prin punct si virgula',
    skusTaxRate: 'Rata taxa SKU-uri',
    useOrderDates: 'Foloseste datele de creare a comenzilor pentru facturi',
    convertCurrency: 'Converteste preturile in valuta in care plateste clientul',
    unsavedChanges: 'Modificari nesalvate',
    discard: 'Renunta',
    save: 'Salveaza',
  },
  drafts: {
    pageTitle: 'Ciorne',
    pageDescription: 'Manage your draft orders',
    title: 'Ciorne',
    download: 'Descarca',
    newDraft: 'Ciorna noua',
    exporting: 'Se exporta {status}%...',
    accessNotGranted: 'Accesul la Comenzi ciorna nu a fost acordat. Va rugam',
    reLogin: 'reconectati-va',
    toGrantPermissions: 'pentru a acorda permisiunile necesare "Comenzi ciorna".',
    pushFailed: 'Trimiterea catre Shopify a esuat:',
    exportError: 'Eroare la export:',
    confirmDelete: 'Sunteti sigur ca doriti sa stergeti aceasta ciorna?',
    incompleteCustomer: 'Datele clientului sunt incomplete:',
    pushWithoutCustomer: 'Ciorna va fi trimisa catre Shopify fara datele clientului. Continuati?',
    customerNotInShopify: 'Acest client nu exista inca in Shopify.',
    warnings: 'Avertismente:',
    createCustomerAndPush: 'Creati clientul in Shopify si trimiteti comanda ciorna?',
    downloadTitle: 'Descarcă ciorne',
    cancel: 'Anulează',
  },
  draftEdit: {
    number: "Număr",
    prefix: "Prefix",

    newDraft: 'Ciorna noua',
    editDraft: 'Editeaza ciorna',
    viewInShopify: 'Vezi in Shopify',
    back: 'Inapoi',
    createDraft: 'Creeaza ciorna',
    saveChanges: 'Salveaza modificarile',
    documentType: 'Tip document',
    draftOrder: 'Comanda ciorna',
    quote: 'Oferta',
    proforma: 'Proforma',
    manualInvoice: 'Factura manuala',
    currency: 'Valuta',
    expiryDate: 'Data expirare',
    status: 'Status',
    draft: 'Ciorna',
    sent: 'Trimis',
    accepted: 'Acceptat',
    customer: 'Client',
    firstName: 'Prenume',
    lastName: 'Nume',
    email: 'Email',
    phone: 'Telefon',
    company: 'Companie',
    taxId: 'Cod fiscal',
    billingAddress: 'Adresa de facturare',
    address: 'Adresa',
    aptSuite: 'Ap/Bloc',
    city: 'Oras',
    province: 'Judet',
    countryField: 'Tara',
    zip: 'Cod postal',
    shippingAddress: 'Adresa de livrare',
    sameAsBilling: 'La fel ca facturarea',
    lineItems: 'Articole',
    shipping: 'Livrare',
    shippingTitle: 'Titlu',
    shippingPlaceholder: 'ex. Livrare standard',
    price: 'Pret',
    note: 'Nota',
    notePlaceholder: 'Nota interna sau mesaj catre client...',
    summary: 'Sumar',
    subtotal: 'Subtotal',
    discounts: 'Reduceri',
    tax: 'Taxa',
    total: 'Total',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Introduceti adresa magazinului',
    loginWith: 'Autentificare cu',
    createAccount: 'Creeaza un cont nou',
    placeholder: 'numele-magazinului-tau',
    shopRequired: 'Numele magazinului este obligatoriu',
    login: 'Autentificare',
    shopify: 'Shopify',
    terms: 'Termeni si conditii',
    privacy: 'Politica de confidentialitate',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Va place Invoice Browse?',
    description: 'Ati creat primele facturi! Daca gasiti aplicatia utila, o recenzie rapida pe Shopify App Store ne ajuta foarte mult.',
    reward: 'Ca multumire, vom reseta contorul de utilizare lunara la 0',
    leaveReview: 'Lasa o recenzie',
    maybeLater: 'Poate mai tarziu',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Bine ati venit la Invoice Browse',
    welcomeContent: 'Permiteti-mi sa va arat cum il puteti folosi.',
    dashboardTitle: 'Panou principal',
    dashboardContent: 'Ecranul pe care il vedeti este panoul principal. Aici puteti gasi toate comenzile si le puteti exporta in diferite tipuri de documente precum: facturi, avize de expeditie si altele.',
    automationTitle: 'Faceti-va viata mai usoara',
    automationContent: 'Activati automatizarea pentru a crea facturi ori de cate ori comenzile sunt platite sau rambursate.',
    templatesTitle: 'Personalizeaza sabloanele',
    templatesContent: 'Intrati aici pentru a traduce sablonul, a-l personaliza sau a crea unul nou.',
    deliveryTitle: 'Livrare',
    deliveryContent: 'Configurati aplicatia noastra pentru a copia automat documentele create pe FTP, Google Drive sau ca atasamente pentru emailuri.',
    settingsTitle: 'Setari',
    settingsContent1: 'Ajustati numarul de telefon al companiei, emailul si alte campuri folosite pe documente.',
    settingsContent2: 'Schimbati numarul de inceput al documentelor sau stergeti documentele create dupa o anumita data.',
    settingsContent3: 'Suprascrieti ratele TVA pentru livrare si produse',
    settingsContent4: 'Schimbati numarul de zecimale pentru numere',
    reviewTitle: 'Scrie o recenzie',
    reviewContent: 'Sustineti echipa noastra scriindu-ne o recenzie buna!',
    tourTitle: 'Tur de bun venit',
    tourContent: 'Hei, puteti deschide din nou acest tur de aici.',
    createDocTitle: 'Creeaza primul document',
    createDocContent: 'Apasati pe butonul Creeaza pentru a crea primul document.',
    docNumberTitle: 'Numar document',
    docNumberContent: 'Primul document are numarul 1 alocat. Daca doriti sa incepeti cu alt numar, puteti schimba acest lucru din Setari.',
    downloadDocTitle: 'Descarca documentul',
    downloadDocContent: 'Apasati pe meniul derulant Descarca si selectati un sablon de document pentru a exporta comanda ca PDF.',
  },
  common: {
    save: 'Salveaza',
    cancel: 'Anuleaza',
    close: 'Inchide',
    discard: 'Renunta',
    delete: 'Sterge',
    edit: 'Editeaza',
    create: 'Creeaza',
    loading: 'Se incarca...',
    unsavedChanges: 'Modificari nesalvate',
    upgradePlan: 'Upgradati planul',
  },
  draftList: {
    draftNum: 'Ciorna #',
    shopifyId: 'Shopify ID',
    type: 'Tip',
    customer: 'Client',
    total: 'Total',
    status: 'Status',
    delivered: 'Livrat',
    date: 'Data',
    actions: 'Actiuni',
    noCustomer: 'Fara client',
    noDrafts: 'Nu s-au gasit ciorne sau oferte.',
    loading: 'Se incarca...',
    download: 'Descarca',
    default: 'Implicit',
    pending: 'In asteptare',
    deliverNow: 'Livreaza acum',
    deliveryDetails: 'Detalii livrare',
    sent: 'Trimis',
    failed: 'Esuat',
    deliverAgain: 'Livreaza din nou',
    partial: 'Partial',
    notDelivered: 'Nelivrat',
    deliveryFailed: 'Livrare esuata',
    unknown: 'Necunoscut',
    edit: 'Editeaza',
    send: 'Trimite',
    pushToShopify: 'Trimite la Shopify',
    complete: 'Finalizeaza',
    duplicate: 'Duplica',
    delete: 'Sterge',
    quote: 'Oferta',
    proforma: 'Proforma',
    draftOrder: 'Comanda ciorna',
    manualInvoice: 'Factura manuala',
  },
  draftSearch: {
    createdBtw: 'Creat intre',
    draftNum: 'Ciorna #',
    shopifyId: 'Shopify ID',
    customer: 'Client',
    status: 'Status',
    type: 'Tip',
    delivery: 'Livrare',
    any: 'Oricare',
    draft: 'Ciorna',
    sent: 'Trimis',
    accepted: 'Acceptat',
    expired: 'Expirat',
    converted: 'Convertit',
    cancelled: 'Anulat',
    quote: 'Oferta',
    proforma: 'Proforma',
    draftOrder: 'Comanda ciorna',
    manualInvoice: 'Factura manuala',
    delivered: 'Livrat',
    notDelivered: 'Nelivrat',
    pending: 'In asteptare',
    search: 'Cauta',
  },
  draftDownload: {
    title: 'Descarca ciorne si oferte...',
    selectTemplate: 'Selectati un sablon din galerie pentru a exporta ciorne, oferte sau proforme.',
    allDraftsBetween: 'Toate ciornele intre',
    selectedDrafts: 'Ciornele selectate',
    and: 'si',
    status: 'Status',
    documentType: 'Tip document',
    any: 'Oricare',
    draft: 'Ciorna',
    sent: 'Trimis',
    accepted: 'Acceptat',
    expired: 'Expirat',
    converted: 'Convertit',
    cancelled: 'Anulat',
    quote: 'Oferta',
    proforma: 'Proforma',
    draftOrder: 'Comanda ciorna',
    manualInvoice: 'Factura manuala',
    format: 'Format',
    noTemplates: 'Nu s-au gasit sabloane',
    noTemplatesForType: 'Nu s-au gasit sabloane pentru tipul de document "{type}".',
    installTemplates: 'Instalati sabloane',
    toStartExporting: 'pentru a incepe exportul.',
    noteChrome: 'Nota: Pentru descarcare optima se recomanda browserul Chrome si dezactivarea oricarui Adblocker.',
    cancel: 'Anuleaza',
    downloadIndividually: 'Descarca individual',
    downloadGrouped: 'Descarca grupat',
  },
  languageSelector: {
    label: 'Limba',
    auto: 'Detectare automata',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Instaleaza sablon nou',
    tabStyle: 'Stil',
    tabContent: 'Continut',
    tabTranslations: 'Traduceri',
    tabSettings: 'Setari',
    tabCode: 'Cod',
    tabCopilot: 'AI Copilot',
    logo: 'Logo',
    colorPalette: 'Paleta de culori',
    colorText: 'Text',
    colorBg: 'Fundal',
    colorBorder: 'Bordura',
    colorPrimary: 'Primar',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Implicit (DM Sans)',
    fontSize: 'Dimensiune font',
    fontSizeDefault: 'Implicit (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Mic',
    fontSizeMediumSmall: 'Mediu mic',
    fontSizeMedium: 'Mediu',
    fontSizeMediumLarge: 'Mediu mare',
    fontSizeLarge: 'Mare',
    fontSizeExtraLarge: 'Extra mare',
    documentTitle: 'Titlu document',
    documentTitlePlaceholder: 'ex. Factura, Factura fiscala...',
    noToggleSupport: 'Acest sablon nu suporta controale toggle. Treceti la un sablon din galerie pentru personalizare completa.',
    sections: 'Sectiuni',
    shippingAddress: 'Adresa de livrare',
    bankPaymentDetails: 'Detalii bancare / plata',
    paymentStatusBadge: 'Insigna stare plata',
    orderNotes: 'Note comanda',
    trackingFulfillment: 'Informatii urmarire / onorare',
    termsConditions: 'Termeni si conditii',
    signatureLines: 'Linii semnatura',
    qrCode: 'Cod QR',
    lineItems: 'Articole',
    taxColumns: 'Coloane taxe (TVA / GST)',
    productSku: 'SKU produs',
    productImages: 'Imagini produs',
    discountBreakdown: 'Detaliere reducere',
    itemWeight: 'Greutate articol',
    hsCode: 'Cod HS (vama)',
    mergeDiscounts: 'Unifica reducerile in pretul produsului',
    showOrderDiscountAsSummary: 'Afiseaza reducerea la nivel de comanda ca linie de sumar',
    totals: 'Totaluri',
    subtotalBeforeTax: 'Subtotal (inainte de taxa)',
    taxBreakdownByRate: 'Detaliere taxa pe rata',
    shippingCostSeparate: 'Cost livrare ca linie separata',
    dueDate: 'Data scadenta',
    formatting: 'Formatare',
    dateFormat: 'Format data',
    decimalPlaces: 'Zecimale',
    paymentTerms: 'Termeni de plata',
    paymentTermsNone: 'Niciunul',
    thankYouMessage: 'Mesaj de multumire',
    thankYouPlaceholder: 'Va multumim pentru comanda!',
    countryMatchTitle: 'Foloseste acest sablon cand adresa de livrare sau facturare corespunde acestei tari',
    addressType: 'Tip adresa',
    addressDisabled: 'Dezactivat',
    addressShipping: 'Adresa de livrare',
    addressBilling: 'Adresa de facturare',
    country: 'Tara',
    anyCountry: 'Orice tara',
    countryMatchDesc: 'Cand este activat, acest sablon va fi folosit automat pentru comenzile in care adresa selectata corespunde tarii alese.',
    languagePreset: 'Preset limba',
    selectLanguage: 'Selectati o limba...',
    languagePresetDesc: 'Selectarea unei limbi completeaza toate etichetele de mai jos. Puteti apoi personaliza campurile individuale.',
    paperSize: 'Dimensiune hartie',
    format: 'Format',
    orientation: 'Orientare',
    portrait: 'Portret',
    landscape: 'Peisaj',
    margin: 'Margine (cm)',
    template: 'Sablon',
    templateName: 'Nume',
    systemAlias: 'Alias sistem',
    systemAliasDesc: 'pentru rute POS/Admin URL',
    systemAliasNone: 'Niciunul',
    defaultTemplate: 'Sablon implicit',
    defaultTemplateDesc: 'Folosit pentru linkuri directe partajate cu clientii.',
    posRouteDesc: 'Mapeaza la /template/[alias]/receipt.pdf pentru integrarea POS.',
    documentType: 'Tip document',
    invoiceCreditNote: 'Factura + Nota de credit',
    order: 'Comanda',
    invoiceOnly: 'Doar factura',
    quoteEstimate: 'Oferta / Estimare',
    proformaInvoice: 'Factura proforma',
    refund: 'Rambursare',
    stornoInvoice: 'Factura storno',
    creditNoteOnly: 'Doar nota de credit',
    reportLiquid: 'Raport (doar Liquid)',
    hideRemovedItems: 'Ascunde articolele eliminate/rambursate',
    location: 'Locatie',
    locationEmpty: 'Lasati gol pentru a folosi la toate locatiile',
    dangerZone: 'Zona periculoasa',
    dangerZoneDesc: 'Sterge permanent acest sablon din contul dumneavoastra.',
    removeTemplate: 'Sterge sablonul',
    bodyTemplate: 'Sablon corp',
    bodyTemplateDesc: 'Foloseste sintaxa Mustache sau Liquid. Click pe un fragment:',
    rowTemplate: 'Sablon rand',
    rowTemplateDesc: 'Randat o data per articol. Click pe un fragment:',
    variableReference: 'Referinta variabile',
    formatCode: 'Formateaza codul',
    insert: 'Insereaza',
    copy: 'Copiaza',
    loadModelContinue: 'Incarca modelul si continua',
    cancel: 'Anuleaza',
    copilotPlaceholder: 'Incearca: traducere in romana, arata coloane taxe, adauga cod de bare, schimba paleta...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Anuleaza',
    redo: 'Refaci',
    aiThinking: 'AI se gandeste...',
    proposedChanges: 'Modificari propuse',
    applyChanges: 'Aplica modificarile',
    dismiss: 'Respinge',
    aiEngineReady: 'Motor AI pregatit',
    loadingAiModel: 'Se incarca modelul AI...',
    aiEngineOff: 'Motor AI oprit —',
    loadForAdvanced: 'incarca pentru editari avansate',
    instantCommands: 'traducere, arata/ascunde sectiuni, adauga fragmente, schimba font/culori/hartie',
    aiEngineDesc: 'editari structurale HTML, modificari de layout, modificari personalizate',
    aiLocalDesc: 'Modelul ruleaza local prin WebGPU — nicio data nu paraseste browserul. Modelele mai mari sunt mai precise dar consuma mai mult VRAM.',
    aiUpgradeDesc: 'upgradati la Starter sau Professional pentru a debloca editarea avansata AI a sabloanelor.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Incarca motorul AI?',
    loadAiDesc: 'Modelul AI pe dispozitiv se va descarca si rula local folosind WebGPU. Necesita ~1-3 GB de VRAM/RAM liber si un GPU modern (Mac M1+, sau GPU dedicat pe Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/ro.js